import { Flex } from '@repo/ui/Flex';
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader';
import s from './Step.module.css';
import { Collapsible } from '@repo/ui/Collapsible';

export const ItemLoader = () => (
  <div className={s.item}>
    <div className={s.itemImage}>
      <div className={s.imageWrap}>
        <SkeletonLoader
          layout={{
            items: {
              default: [
                {
                  columns: 12,
                  height: 264,
                  startColumn: 1,
                  startRow: 1,
                },
              ],
              mobile: [
                {
                  columns: 12,
                  height: 72,
                  startColumn: 1,
                  startRow: 1,
                },
              ],
            },
          }}
        />
      </div>
    </div>

    <div className={s.itemDetails}>
      <SkeletonLoader
        layout={{
          items: {
            default: [
              {
                columns: 9,
                startRow: 1,
              },
              {
                columns: 3,
                rows: 1,
                startRow: 2,
              },
            ],
            mobile: [
              {
                columns: 11,
                startColumn: 2,
                startRow: 1,
              },
              {
                columns: 6,
                startColumn: 2,
                rows: 1,
                startRow: 2,
              },
            ],
          },
        }}
      />
    </div>

    <Flex
      direction="column"
      gap="g-16"
      className={s.itemTasks}
      padding={['py-16', 'md:py-0']}
    >
      <Collapsible
        header={
          <SkeletonLoader
            layout={{
              items: {
                default: [
                  {
                    columns: 12,
                    startRow: 1,
                  },
                ],
              },
            }}
          />
        }
      >
        <SkeletonLoader
          layout={{
            items: {
              default: [
                {
                  columns: 1,
                  startRow: 1,
                },
                {
                  columns: 3,
                  startColumn: 2,
                  startRow: 1,
                },
                {
                  columns: 3,
                  startColumn: 5,
                  startRow: 1,
                },
                {
                  columns: 3,
                  startColumn: 8,
                  startRow: 1,
                },
                {
                  columns: 2,
                  startColumn: 11,
                  startRow: 1,
                },
                {
                  columns: 3,
                  startColumn: 1,
                  startRow: 2,
                },
                {
                  columns: 3,
                  startColumn: 4,
                  startRow: 2,
                },
                {
                  columns: 2,
                  startColumn: 7,
                  startRow: 2,
                },
                {
                  columns: 2,
                  startColumn: 9,
                  startRow: 2,
                },
                {
                  columns: 2,
                  startColumn: 11,
                  startRow: 2,
                },
              ],
              mobile: [
                {
                  columns: 2,
                  startColumn: 1,
                  startRow: 1,
                },
                {
                  columns: 5,
                  startColumn: 3,
                  startRow: 1,
                },
                {
                  columns: 5,
                  startColumn: 1,
                  startRow: 2,
                },
                {
                  columns: 5,
                  startColumn: 6,
                  startRow: 2,
                },
                {
                  columns: 3,
                  startColumn: 1,
                  startRow: 3,
                },
                {
                  columns: 5,
                  startColumn: 4,
                  startRow: 3,
                },
                {
                  columns: 5,
                  startColumn: 1,
                  startRow: 4,
                },
                {
                  columns: 4,
                  startColumn: 6,
                  startRow: 4,
                },
                {
                  columns: 4,
                  startColumn: 1,
                  startRow: 5,
                },
                {
                  columns: 4,
                  startColumn: 5,
                  startRow: 5,
                },
              ],
            },
          }}
        />
      </Collapsible>
    </Flex>
  </div>
);
